import * as React from "react"
import { Link } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

export default function DonwloadManualButton ({ manualLink }) {

    return <Link href={manualLink} target="_blank">
            <ButtonIconSeeker 
                icon={'circle-info'} 
                tooltip={'Download user manual'}
                sx={{color: "text.contrastText"}} 
            />
    </Link>
}